import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Fix: Prevent "removeChild" errors from external scripts (Emergent badge, PostHog, etc.)
// conflicting with React's virtual DOM on mobile browsers
const originalRemoveChild = Node.prototype.removeChild;
Node.prototype.removeChild = function(child) {
  if (child.parentNode !== this) {
    console.warn('removeChild: node is not a child - suppressed');
    return child;
  }
  return originalRemoveChild.call(this, child);
};

const originalInsertBefore = Node.prototype.insertBefore;
Node.prototype.insertBefore = function(newNode, referenceNode) {
  if (referenceNode && referenceNode.parentNode !== this) {
    console.warn('insertBefore: reference node is not a child - suppressed');
    return newNode;
  }
  return originalInsertBefore.call(this, newNode, referenceNode);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
